<template>
  <v-container>
    <v-layout justify-center row>
      <v-flex>
    <v-form @submit.prevent="onSubmit" novalidate class="elevation-2 pa-3">
      <Fields
        v-bind="{fields, object: formData, errors: formErrors}">
      </Fields>

      <v-btn type="submit" color="primary">Zapisz</v-btn>
    </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {createPulseZones, updatePulseZones} from './api'
import _ from 'lodash'
import { mapState } from 'vuex'
import Fields from '@/forms/Fields'
import formMixin from '@/utils/formMixin'
import store from '@/store'
import * as types from '@/store/mutation-types'

export default {
  components: {Fields},
  mixins: [formMixin],
  props: {
    pulseZones: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      isUpdate: false
    }
  },
  computed: {
    ...mapState(['runner']),
    fields () {
      return [
        {comp: 'date', id: 'test_date', label: 'Data badania'},
        {comp: 'text', id: 'zone_1', label: 'Strefa regeneracji aktywnej', props: {suffix: '[bpm]'}},
        {comp: 'text', id: 'zone_2', label: 'Próg tlenowy', props: {suffix: '[bpm]'}},
        {comp: 'text', id: 'zone_4', label: 'Próg anaerobowy', props: {suffix: '[bpm]'}},
        {comp: 'text', id: 'hrmax', label: 'HRmax', props: {suffix: '[bpm]'}}
      ]
    },
    message () {
      return this.isUpdate ? 'Test został edytowany' : 'Test został dodany'
    }
  },
  created () {
    this.formData = _.cloneDeep(this.pulseZones)
    if (this.pulseZones.id) {
      this.isUpdate = true
    }
  },
  methods: {
    submit (data) {
      if (this.isUpdate) {
        return updatePulseZones(this.runner, data).then((data) => {
          store.dispatch(types.RUNNER_REQUEST, [this.runner.id, true])
          return data
        })
      } else {
        return createPulseZones(this.runner, data).then((data) => {
          store.dispatch(types.RUNNER_REQUEST, [this.runner.id, true])
          this.formData = {}
          this.validation.reset()
          return data
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/physical_tests/PulseZonesForm.vue